module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_popout-a15933ee4d705648fe54fb37ee301045.png";